import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Alert as MuiAlert,
  Box,
  Button as MuiButton,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  TextField as MuiTextField,
  Typography,
  Card as MuiCard,
  Divider as MuiDivider
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { spacing } from "@mui/system";
import KPIDialog from "../../../components/dialogs/KPIDialog";
import DataGridKPIs from "../../../components/datagrids/DataGridKPIs";
import { DialogMode } from "../../../types/dialogmode";
import { t } from "i18next";
import BreadCrumbsBar from "../../../components/breadcrumbsBar/BreadCrumbsBar";

const Alert = styled(MuiAlert)(spacing);
const Button = styled(MuiButton)(spacing);
const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

function KPIList({ ...props }) {
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (refetch) {
      setRefetch(false);
    }
  }, [refetch]);

  return (
    <React.Fragment>
      <Helmet title="Vendors" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid>
          <Typography variant="h3" gutterBottom display="inline">
            {t("KPI's")}
          </Typography>

          <BreadCrumbsBar mt={2}>
            <Link component={NavLink} to="/libraries">
              {t("Libraries")}
            </Link>
            <Typography> {t("KPI's")}</Typography>
          </BreadCrumbsBar>
        </Grid>
        <Grid>
          <KPIDialog mode={DialogMode.Add} refetch={() => setRefetch(true)} />
        </Grid>
      </Grid>
      <Divider my={6} />

      <Box mb={6}>
        By requesting these KPIs from vendors, you can gather valuable
        information to assess their capabilities, performance, and alignment
        with your organization's requirements.
      </Box>

      <DataGridKPIs view="grid" refetch={refetch} />
    </React.Fragment>
  );
}

export default KPIList;
